import { apiFetch } from "@/lib/api";

export { WORKSPACE_AVATAR_SYNC_OPERATOR_EMAIL } from "@/lib/workspaceAvatarSync";

export interface QuickBooksAccountingOAuthStatus {
  clientConfigured: boolean;
  connected: boolean;
  tokenHealthy: boolean;
  needsReconnect: boolean;
  needsReconnectSoon: boolean;
  operatorEligible: boolean;
  expiresAt: string | null;
  refreshTokenExpiresAt: string | null;
  connectedAt: string | null;
  connectedByUserId: string | null;
  connectedByLabel: string | null;
  qboRealmId: string | null;
}

export function fetchQuickBooksAccountingOAuthStatus(): Promise<QuickBooksAccountingOAuthStatus> {
  return apiFetch<QuickBooksAccountingOAuthStatus>("/api/accounting/quickbooks/oauth/status");
}

export function startQuickBooksAccountingOAuth(input: {
  returnTo?: string;
  uiOrigin?: string;
}): Promise<{ authorizeUrl: string; expiresAt: string }> {
  return apiFetch("/api/accounting/quickbooks/oauth/start", {
    method: "POST",
    body: input,
  });
}

export function disconnectQuickBooksAccountingOAuth(): Promise<{ disconnected: boolean }> {
  return apiFetch("/api/accounting/quickbooks/oauth/disconnect", {
    method: "POST",
  });
}
